import { combineReducers } from 'redux';
import { user } from './user';
import { page } from './page';
import { tenant } from './tenant';

export default combineReducers({user, page, tenant});


// WEBPACK FOOTER //
// ./src/redux/reducer/index.js